export enum ACTION_TYPE {
	GET_LINEAGE = 'Get Lineage',
	GET_LINEAGE_COUNT = 'Get Lineage Count',
	VISUALIZE_LINEAGE_COUNT = 'Visualize Lineage Count',
	GET_RESOURCE = 'Get Resource',
	GET_RESOURCE_COUNT = 'Get Resource Count',
	QUERY_ELASTICSEARCH = 'Query Secoda Documents',
	DOWNLOAD_S3_FILE = 'Download S3 File',
	GET_WORKSPACE_USERS = 'Get Workspace Users',
	GET_WORKSPACE_ADMINS = 'Get Workspace Admins',
	INSPECT_CACHE = 'Inspect Cache',
	DELETE_FROM_CACHE = 'Clear Cache Key',
	CLEAR_QUERY_PARSE_RESULTS = 'Clear Query Parse Results',
	UPDATE_ALLOWED_DOMAINS = 'Update Allowed Domains',
	UPDATE_DISABLED = 'Update Disabled',
	GET_WORKSPACE = 'Get Workspace',
	REGENERATE_WORKSPACE_POLICIES = 'Regenerate Workspace Policies',
	UPDATE_WORKSPACE_QUALITY_FLAGS = 'Update Workspace Quality Flags',
	RESET_DQS2_POLICIES = 'Reset DQS2 Policies',
	TEST_REVERSE_TUNNEL = 'Test Reverse Tunnel',
	TEST_CONNECTIVITY = 'Test Integration Connectivity',
	BULK_EXPORT = 'Bulk Export',
	REGENERATE_TEAMS_PERMISSIONS = 'Regenerate Teams Permissions',
	GENERATE_WORKSPACE_LINEAGE = 'Generate Workspace Lineage',
	REMOVE_DISABLED_USERS_FROM_TEAMS = 'Remove Disabled Users From Teams',
}

export type ActionsPageTab = {
	key: string;
	label: string;
	actionType?: ACTION_TYPE;
};

export type ActionField = {
	label: string;
	value: string;
	group?: string;
	type: 'string' | 'boolean' | 'select';
	display?: 'textarea' | 'text';
	options?: string[];
};

export type ActionFields = Record<ACTION_TYPE, ActionField[]>;

export type GroupedActionFields = Record<
	string,
	{ string: ActionField[]; boolean: ActionField[]; select: ActionField[] }
>;
